export const PROFILE_REQUEST = "PROFILE_REQUEST";
export const PROFILE_SUCCESS = "PROFILE_SUCCESS";
export const PROFILE_FAILURE = "PROFILE_FAILURE";

export const ADDRESS_REQUEST = "ADDRESS_REQUEST";
export const ADDRESS_SUCCESS = "ADDRESS_SUCCESS";
export const ADDRESS_FAILURE = "ADDRESS_FAILURE";

export const CART_REQUEST = "CART_REQUEST";
export const CART_SUCCESS = "CART_SUCCESS";
export const CART_FAILURE = "CART_FAILURE";

export const MYORDERS_REQUEST = "MYORDERS_REQUEST";
export const MYORDERS_SUCCESS = "MYORDERS_SUCCESS";
export const MYORDERS_FAILURE = "MYORDERS_FAILURE";


export const EMPTY_CART_REQUEST = "EMPTY_CART_REQUEST";
export const EMPTY_CART_SUCCESS = "EMPTY_CART_SUCCESS";
export const EMPTY_CART_FAILURE = "EMPTY_CART_FAILURE";


